<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    id="sign-widget-dialog"
    v-show="visible"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <button type="button" class="close" @click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div
            id="sign-widget-parent"
            style="width:100%;height:500px;"
            v-show="showParent"
            ref="iframeContainer"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global EndUser */

const SIGN_WIDGET_PARENT_ID = "sign-widget-parent";
const SIGN_WIDGET_ID = "sign-widget";

import { config } from '../../config';

export default {
  name: "SignWidgetDialog",
  props: {
    signature: String
  },
  data() {
    return {
      visible: false,
      showParent: true,
      euSign: null
    };
  },
  computed: {
    title() {
      return this.$store.state.localization.data?.eusign.title;
    }
  },
  methods: {
    open() {
      this.visible = true;

      this.euSign = new EndUser(
          SIGN_WIDGET_PARENT_ID,
          SIGN_WIDGET_ID,
          config.eusign.url,
          EndUser.FormType.ReadPKey
      );
    },

    async getSignature() {
      await this.readPrivateKey();

      const signedHash = await this.signFilesHash(this.signature);
      return signedHash;
    },

    close() {
      this.visible = false;
    },

    async readPrivateKey() {
      try {
        await this.euSign.ReadPrivateKey();
        return;
      } catch (e) {
        throw 'Виникла помилка при зчитуванні ос. ключа. Опис помилки: ' + (e.message || e);
      }
    },

    async signFilesHash(hashesToSign) {
      const previousSign = null;
      const asBase64String = true;
      const signAlgo = EndUser.SignAlgo.DSTU4145WithDSTU7564;
      const signType = EndUser.SignType.CAdES_X_Long;

      try {
        const signature = await this.euSign.SignHash(
          hashesToSign,
          asBase64String,
          signAlgo,
          signType,
          previousSign
        );

        return signature;
      } catch (e) {
        throw 'Виникла помилка при підписі даних. Опис помилки: ' + (e.message || e);
      }
    }
  }
};
</script>

<style scoped>
.modal {
  display: block;
  background: rgba(0, 0, 0, 0.5);
}
</style>
